import React from "react";
import styled from "styled-components";

interface ContainerHeaderProps {
  title: string;
  description: string;
  rightSideContent?: React.ReactNode;
  additionalLinkText?: string;
}

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: var(--sumi-header-background);
  text-align: left;
  padding: 2rem 4rem 2rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: var(--sumi-text-primary);
  height: 80px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 500;
`;

const Description = styled.p`
  margin: 10px 0 0 0;
  font-size: 16px;
  color: var(--sumi-text-primary);
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--sumi-background-blue);

  @media (max-width: 1028px) {
    flex-direction: column;
    padding-bottom: 2rem;
  }
`;

const ContainerHeader: React.FC<ContainerHeaderProps> = ({}) => {
  return (
    <Container>
      {/* <Title>{title}</Title>
      <Description>
        <span>{description}</span>
        <span>
          &nbsp;<a href={"https://www.google.com"}>{additionalLinkText}</a>
        </span>
      </Description> */}
    </Container>
  );
};

export default ContainerHeader;
